import { EmploymentScheduleDay } from '../../../../types/backendResponses/EmploymentScheduleDay';
import { ScheduleDay } from '../types/ScheduleDay';

export const defaultStateScheduleDays: EmploymentScheduleDay[] = [
  {
    day: '',
    endTime: '',
    startTime: '',
    workedHours: '00:00',
  },
  {
    day: '',
    endTime: '',
    startTime: '',
    workedHours: '00:00',
  },
  {
    day: '',
    endTime: '',
    startTime: '',
    workedHours: '00:00',
  },
  {
    day: '',
    endTime: '',
    startTime: '',
    workedHours: '00:00',
  },
  {
    day: '',
    endTime: '',
    startTime: '',
    workedHours: '00:00',
  },
  {
    day: '',
    endTime: '',
    startTime: '',
    workedHours: '00:00',
  },
  {
    day: '',
    endTime: '',
    startTime: '',
    workedHours: '00:00',
  },
];

export const defaultStateScheduleDaysIsChecked = [false, false, false, false, false, false, false];
